export default __webpack_public_path__ + "static/media/scenario-2.4ed27fe2.gif";